"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_div_100vh_1 = __importDefault(require("react-div-100vh"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const forms_1 = require("@/forms");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const LoginScreen = ({ user }) => {
    if (user && user.isValid) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/" });
    }
    return (react_1.default.createElement(react_div_100vh_1.default, { className: styles_scss_1.default.container },
        react_1.default.createElement(components_1.Meta, { title: constants_1.default.login.helmetTitle }),
        react_1.default.createElement("div", { className: styles_scss_1.default.leftContainer },
            react_1.default.createElement("img", { className: styles_scss_1.default.backgroundImage, src: constants_1.Images.loginBackground, alt: constants_1.Images.loginBackground }),
            react_1.default.createElement("div", { className: styles_scss_1.default.leftContainerContent },
                react_1.default.createElement("div", { className: styles_scss_1.default.formContainer },
                    react_1.default.createElement("img", { className: styles_scss_1.default.logo, src: constants_1.Images.logo, alt: "logo" }),
                    react_1.default.createElement(forms_1.LoginForm, null)),
                react_1.default.createElement("div", { className: styles_scss_1.default.leftContainerBottom },
                    react_1.default.createElement("p", null, constants_1.default.login.callUs),
                    react_1.default.createElement(components_1.Anchor, { label: constants_1.default.login.phoneNumber, path: `tel:${constants_1.default.login.phoneNumberRaw}` }),
                    react_1.default.createElement(components_1.Anchor, { className: styles_scss_1.default.privacyPolicy, path: constants_1.PublicUrls.privacyPolicy, label: constants_1.default.login.privacyPolicy })))),
        react_1.default.createElement("div", { className: styles_scss_1.default.rightContainer },
            react_1.default.createElement("img", { src: constants_1.Images.loginBackground, alt: constants_1.Images.loginBackground }))));
};
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
});
exports.default = react_redux_1.connect(mapStateToProps, null)(LoginScreen);
